export const en = {
    'empty-search-result-details': 'Make sure that there are no errors in the query, or try a shorter query',
    'empty-search-result-title': 'No results found',
    'no-variants': 'No options to select from',
    search: 'Search'
};
